<template lang="pug">
   v-text-field(
       v-model="input"
       outline
       label="Buscar"
       append-icon="search"
       @keyup.enter="$emit('search')"
   )
</template>

<script>
export default {
    name: 'data-table-searchbox',
    props: {
        /**
         * @description
         * Search input value
         */
        value: {
            type: String,
            default: () => ''
        },
    },
    data: function(){
        return {}
    },
    computed: {
        input: {
            get: function(){
                return this.value
            },
            set: function(val){
                this.$emit('input', val)
            }
        }
    },
    methods: {},
    watch: {},
    components: {},
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
    
</style>